import axios from "../../util/axios";

export default {
    /** 查询群聊列表 */
    queryList: (data) => axios.get({url: "/wx/quotation/xbot/group/queryList", data}),
    /**变更群聊自动报价*/
    setReply: (data) => axios.get({url: "/wx/quotation/xbot/group/setReply", data}),
    /** 删除群聊 */
    deleteGroup: (data) => axios.del({url: "/wx/quotation/xbot/group/deleteGroup", data}),
    /**获取群聊客户列表*/
    queryGroupMembers:({id}) => axios.get({url: "/wx/quotation/xbot/group/queryGroupMembers", data: {id}}),
    /**刷新群聊客户列表*/
    refreshGroup: (id) => axios.get({url: "/wx/quotation/xbot/group/refreshGroup", data: {id}}),
}